import { Flex, FlexProps, Heading, usePlatformProps } from '@acsbe/ui';
import { FunctionComponent, PropsWithChildren, useId } from 'react';
import { CustomInstallationConfig } from '../../../validations';
import { ContextualSaveBar } from './contextual-save-bar';

export interface PageSectionProps extends PropsWithChildren<FlexProps> {
  title: string;
  style?: React.CSSProperties;
  setWidgetConfig: (config: CustomInstallationConfig | null) => void;
}

export const PageSection: FunctionComponent<PageSectionProps> = ({
  title,
  children,
  ...props
}) => {
  const id = useId();
  const p = usePlatformProps();
  const { setWidgetConfig } = props;

  return (
    <Flex as="section" aria-labelledby={id} scale="base" radius="xl" {...props}>
      <Flex gap="md" radius="xl" height="100%" boxType="border">
        <Flex
          row
          height="40px"
          align="center"
          justify="space-between"
          paddingBlockStart={6}
        >
          <Heading
            level={2}
            size="xxs"
            emphasis="high"
            balance={false}
            id={id}
            {...p.uptoTablet({ style: { fontSize: 16 } })}
          >
            {title}
          </Heading>
          <ContextualSaveBar setWidgetConfig={setWidgetConfig} />
        </Flex>

        {children}
      </Flex>
    </Flex>
  );
};
